import Api from '@/services/api';
import {useRoleStore} from '@store/roleStore';

export default {
  roles() {
    return Api()
      .get('/roles')
      .then((res) => res.data);
  },
  permissions(roleId) {
    return Api()
      .get('/role/' + roleId + '/permissions')
      .then((res) => res.data);
  },
  roleStorage() {
    let store = useRoleStore();
    return store.all();
  },
};
